// Грид-позиция столбиков, с которой начинаются офферы (динамической ширины и количества)
export const DYNAMIC_COLUMNS_START = 8;
export const GENERAL_ESTIMATE_COLUMN_START = 4;
export const GENERAL_ESTIMATE_COLUMN_WIDTH = 4;
// Ширина обычного закрытого оффера
export const DEFAULT_COLUMN_WIDTH = 2;
// На сколько отличается ширина оффера в открытом состоянии
export const WIDE_COLUMN_DELTA = 3;
export const HEADER_ROW_START = 1;
export const HEADER_ROW_CENTER = 2;
export const HEADER_ROW_END = 3;
export const BREAKDOWN_COEFFICIENT = 2;
// Нижняя граница первой строчки тендера в таблице тендеров
export const FIRST_DYNAMIC_ROW_END = 4;
export const STATIC_UNIT_QUANTITY_WIDTH = 2;
